export const PROGRAMMING = "programming";
export const VIDEO = "videoReview";
export const COMMENTARY = "commentaryReview";
export const CHECKIN = "checkInReview";
export const OTHER = "other";

export const getAthleteFromId = (id, athletes) => {
  return athletes.find(
    (athlete) => athlete._id === id || String(athlete._id) === String(id)
  );
};

export const getAthleteInfo = ({ _id, name, email, avatar }) => {
  return {
    _id,
    name,
    email,
    avatar,
  };
};
